import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiAction } from "../../store/ui-gemini";

const LoginRequiredModal = () => {
  const dispatch = useDispatch();
  const open = useSelector((s) => s.ui.isLoginRequiredModalOpen);
  if (!open) return null;

  const close = (e) => {
    e?.stopPropagation?.();
    dispatch(uiAction.closeLoginRequiredModal());
  };

  const gotoLogin = () => {
    window.location.href = "/login";
  };

  return (
    <div onClick={close} className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60">
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg shadow-xl w-[90vw] max-w-sm p-5 text-center">
        <h3 className="text-lg font-semibold text-gray-900 mb-2 text-left">Login required</h3>
        <p className="text-sm text-left text-gray-600 mb-4">You need to login to continue using this feature.</p>
        <div className="flex gap-3 justify-end">
          <button onClick={gotoLogin} className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 active:scale-[0.98]">Login</button>
          <button onClick={close} className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 active:scale-[0.98]">Later</button>
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredModal;


